// const BASE_URL: string = 'http://178.128.61.122:8094';
const BASE_URL = process.env.REACT_APP_API_KEY;

export const FIND_MANY_PROMOTION = BASE_URL + '/promotion/promotion/find-many';
export const CREATE_PROMOTION = BASE_URL + '/promotion/promotion/create';
export const UPDATE_PROMOTION = BASE_URL + 'promotion/promotion/update?Id=';
export const DELETE_PROMOTION = BASE_URL + '/promotion/promotion/delete?Id=';

export const TAG_PROMOTION_FIND_MANY = BASE_URL + '/promotion/tag-promotion/find-many';
export const CREATE_TAG_PROMOTION = BASE_URL + '/promotion/tag-promotion/create';
export const UPDATE_TAG_PROMOTION = BASE_URL + '/promotion/tag-promotion/update/';
export const DELETE_TAG_PROMOTION = BASE_URL + '/promotion/tag-promotion/delete/';

export const IMAGE_PRO_URL = BASE_URL + '/promotion/api/';
export const UPLOAD_IMAGE_PROMOTION: string = BASE_URL + '/promotion/promotion/upload-pic?Id=';
export const CHECK_CREATE_PROMOTION: string = BASE_URL + '/promotion/promotion/check-promotion';